// @flow

export const FILTER_TAB = 'FilterTab';
export const FILTER_OPTIONS_TAB = 'FilterOptionsTab';
export const SORT_BY_TAB = 'SortByTab';
export const SEARCH_RESULT_PAGE_TAB = 'SearchResultPageTab';
export const COLLECTION_PAGE_TAB = 'CollectionPageTab';
export const INSTANT_SEARCH_DISPLAY_TAB = 'InstantSearchDisplayTab';
export const ERROR_TAB = 'ErrorTab';
export const DEFAULT_THEME_TAB = 'DefaultThemeTab';
export const QUICK_VIEW_TAB = 'QuickViewTab';
export const ADD_TO_CART_TAB = 'AddToCartTab';
export const RECENT_VIEW_MOST_POPULAR_TAB = 'RecentlyViewedMostPopularTab';
export const SEARCH_PAGE_TAB = 'SearchPageTab';
export const PRODUCT_TAB = 'ProductTab';
export const RECOMMENDATION_TAB = 'RecommendationTab';
export const NO_RESULTS_DISPLAY = 'NoResultsDisplayTab';
export const OLD_VERSION_TAB = 'OldVersionTab';
export const PREDICTIVE_BUNDLE_TAB = 'PredictiveBundleTab';

export const TRANSLATION_FEATURE_GROUP = {
  FILTER: 'filter',
  SEARCH: 'search',
  OTHERS: 'others',
}

export const OTHER_TAB_ORDER = [
  PRODUCT_TAB,
  RECOMMENDATION_TAB,
  PREDICTIVE_BUNDLE_TAB,
  SORT_BY_TAB,
  OLD_VERSION_TAB,
];

export const TAB_V1 = [
  {
    id: 'filter',
    content: `AdminHTML.Translation.${FILTER_TAB}.title`,
    panelID: 'filter-content',
    name: FILTER_TAB,
    group: TRANSLATION_FEATURE_GROUP.FILTER
  },
  {
    id: 'sort-by',
    content: `AdminHTML.Translation.${SORT_BY_TAB}.title`,
    panelID: 'sort-by-content',
    name: SORT_BY_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  },
  {
    id: 'search-result-page',
    content: `AdminHTML.Translation.${SEARCH_RESULT_PAGE_TAB}.title`,
    panelID: 'search-result-page',
    name: SEARCH_RESULT_PAGE_TAB,
    group: TRANSLATION_FEATURE_GROUP.SEARCH
  },
  {
    id: 'collection-page',
    content: `AdminHTML.Translation.${COLLECTION_PAGE_TAB}.title`,
    panelID: 'collection-page',
    name: COLLECTION_PAGE_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  },
  {
    id: 'suggestion',
    content: `AdminHTML.Translation.${INSTANT_SEARCH_DISPLAY_TAB}.title`,
    panelID: 'suggestion-content',
    name: INSTANT_SEARCH_DISPLAY_TAB,
    group: TRANSLATION_FEATURE_GROUP.SEARCH
  },
  {
    id: 'error',
    content: `AdminHTML.Translation.${ERROR_TAB}.title`,
    panelID: 'error-content',
    name: ERROR_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  },
  {
    id: 'default-theme',
    content: `AdminHTML.Translation.${DEFAULT_THEME_TAB}.title`,
    panelID: 'default-theme-content',
    name: DEFAULT_THEME_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  },
  {
    id: 'quick-view',
    content: `AdminHTML.Translation.${QUICK_VIEW_TAB}.title`,
    panelID: 'quick-view-content',
    name: QUICK_VIEW_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  },
  {
    id: 'add-to-card',
    content: `AdminHTML.Translation.${ADD_TO_CART_TAB}.title`,
    panelID: 'add-to-cart-content',
    name: ADD_TO_CART_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  },
  {
    id: 'recently-viewed-most-popular',
    content: `AdminHTML.Translation.${RECENT_VIEW_MOST_POPULAR_TAB}.title`,
    panelID: 'recently-viewed-most-popular-content',
    name: RECENT_VIEW_MOST_POPULAR_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  }
];

export const TAB_V2 = [
  {
    id: 'filter',
    content: `AdminHTML.Translation.${FILTER_TAB}.title`,
    panelID: 'filter-content',
    name: FILTER_TAB,
    group: TRANSLATION_FEATURE_GROUP.FILTER
  },
  {
    id: 'filter-options',
    content: `AdminHTML.Translation.${FILTER_OPTIONS_TAB}.title`,
    panelID: 'filter-options-content',
    name: FILTER_OPTIONS_TAB,
    group: TRANSLATION_FEATURE_GROUP.FILTER
  },
  {
    id: 'sort-by',
    content: `AdminHTML.Translation.${SORT_BY_TAB}.title`,
    panelID: 'sort-by-content',
    name: SORT_BY_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  },
  {
    id: 'search-result-page',
    content: `AdminHTML.Translation.${SEARCH_PAGE_TAB}.title`,
    panelID: 'search-result-page',
    name: SEARCH_PAGE_TAB,
    group: TRANSLATION_FEATURE_GROUP.SEARCH
  },
  {
    id: 'suggestion',
    content: `AdminHTML.Translation.${INSTANT_SEARCH_DISPLAY_TAB}.title`,
    panelID: 'suggestion-content',
    name: INSTANT_SEARCH_DISPLAY_TAB,
    group: TRANSLATION_FEATURE_GROUP.SEARCH
  },
  {
    id: 'product',
    content: `AdminHTML.Translation.${PRODUCT_TAB}.title`,
    panelID: 'product-content',
    name: PRODUCT_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  },
  {
    id: 'recommendation',
    content: `AdminHTML.Translation.${RECOMMENDATION_TAB}.title`,
    panelID: 'recommendation-content',
    name: RECOMMENDATION_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  },
  {
    id: 'predictive-bundle',
    content: `AdminHTML.Translation.${PREDICTIVE_BUNDLE_TAB}.title`,
    panelID: 'predictive-bundle-content',
    name: PREDICTIVE_BUNDLE_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  },
  {
    id: 'error',
    content: `AdminHTML.Translation.${NO_RESULTS_DISPLAY}.title`,
    panelID: 'error-content',
    name: NO_RESULTS_DISPLAY,
    group: TRANSLATION_FEATURE_GROUP.SEARCH
  },
  {
    id: 'old-version',
    content: `AdminHTML.Translation.${OLD_VERSION_TAB}.title`,
    panelID: 'error-content',
    name: OLD_VERSION_TAB,
    group: TRANSLATION_FEATURE_GROUP.OTHERS
  }
];

export const ITEMS_V1 = [
  { name: 'refineDesktop', tab: 'FilterTab' },
  { name: 'refine', tab: 'FilterTab' },
  { name: 'refineMobile', tab: 'FilterTab' },
  { name: 'refineMobileCollapse', tab: 'FilterTab' },
  { name: 'clear', tab: 'FilterTab' },
  { name: 'clearAll', tab: 'FilterTab' },
  { name: 'viewMore', tab: 'FilterTab' },
  { name: 'viewLess', tab: 'FilterTab' },
  { name: 'apply', tab: 'FilterTab' },
  { name: 'applyAll', tab: 'FilterTab' },
  { name: 'close', tab: 'FilterTab' },
  { name: 'back', tab: 'FilterTab' },
  { name: 'showLimit', tab: 'FilterTab' },
  { name: 'collectionAll', tab: 'FilterTab' },
  { name: 'under', tab: 'FilterTab' },
  { name: 'above', tab: 'FilterTab' },
  { name: 'ratingStar', tab: 'FilterTab' },
  { name: 'ratingStars', tab: 'FilterTab' },
  { name: 'ratingUp', tab: 'FilterTab' },
  { name: 'showResult', tab: 'FilterTab' },
  { name: 'searchOptions', tab: 'FilterTab' },

  { name: 'sorting', tab: 'SortByTab' },

  { name: 'generalTitle', tab: 'SearchResultPageTab' },
  { name: 'resultHeader', tab: 'SearchResultPageTab' },
  { name: 'resultNumber', tab: 'SearchResultPageTab' },
  { name: 'seeAllProducts', tab: 'SearchResultPageTab' },
  { name: 'resultEmpty', tab: 'SearchResultPageTab', multiline: 2 },
  { name: 'resultEmptyWithSuggestion', tab: 'SearchResultPageTab', multiline: 2 },
  { name: 'searchTotalResult', tab: 'SearchResultPageTab' },
  { name: 'searchTotalResults', tab: 'SearchResultPageTab' },
  { name: 'searchPanelProduct', tab: 'SearchResultPageTab' },
  { name: 'searchPanelCollection', tab: 'SearchResultPageTab' },
  { name: 'searchPanelPage', tab: 'SearchResultPageTab' },
  { name: 'searchTipsTitle', tab: 'SearchResultPageTab' },
  { name: 'searchTipsContent', tab: 'SearchResultPageTab', multiline: 4 },

  { name: 'inCollectionSearch', tab: 'CollectionPageTab' },
  { name: 'loadPreviousPage', tab: 'CollectionPageTab' },
  { name: 'listView', tab: 'CollectionPageTab' },
  { name: 'gridView', tab: 'CollectionPageTab' },
  { name: 'gridViewColumns', tab: 'CollectionPageTab' },
  { name: 'loadMore', tab: 'CollectionPageTab' },
  { name: 'loadMoreTotal', tab: 'CollectionPageTab' },

  { name: 'viewAll', tab: 'InstantSearchDisplayTab' },
  { name: 'didYouMean', tab: 'InstantSearchDisplayTab' },
  { name: 'searchBoxPlaceholder', tab: 'InstantSearchDisplayTab' },
  { name: 'suggestQuery', tab: 'InstantSearchDisplayTab' },
  { name: 'instantSearchSuggestionsLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'instantSearchCollectionsLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'instantSearchProductsLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'instantSearchPagesLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'searchBoxOnclickRecentSearchLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'searchBoxOnclickSearchTermLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'searchBoxOnclickProductsLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'noSearchResultSearchTermLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'noSearchResultProductsLabel', tab: 'InstantSearchDisplayTab' },

  { name: 'noFilterResult', tab: 'ErrorTab' },
  { name: 'noSearchResult', tab: 'ErrorTab' },
  { name: 'noProducts', tab: 'ErrorTab' },
  { name: 'noSuggestionResult', tab: 'ErrorTab' },
  { name: 'noSuggestionProducts', tab: 'ErrorTab' },

  { name: 'toolbarViewAs', tab: 'DefaultThemeTab' },
  { name: 'toolbarProduct', tab: 'DefaultThemeTab' },
  { name: 'toolbarProducts', tab: 'DefaultThemeTab' },
  { name: 'productItemSoldOut', tab: 'DefaultThemeTab' },
  { name: 'productItemSale', tab: 'DefaultThemeTab' },
  { name: 'productItemFrom', tab: 'DefaultThemeTab' },

  { name: 'qvBtnLabel', tab: 'QuickViewTab' },
  { name: 'qvAddToCartBtnLabel', tab: 'QuickViewTab' },
  { name: 'qvSoldOutLabel', tab: 'QuickViewTab' },
  { name: 'qvSaleLabel', tab: 'QuickViewTab' },
  { name: 'qvViewFullDetails', tab: 'QuickViewTab' },
  { name: 'qvQuantity', tab: 'QuickViewTab' },

  { name: 'atcAvailableLabel', tab: 'AddToCartTab' },
  { name: 'atcSelectOptionsLabel', tab: 'AddToCartTab' },
  { name: 'atcSoldOutLabel', tab: 'AddToCartTab' },
  { name: 'atcMiniCartSubtotalLabel', tab: 'AddToCartTab' },
  { name: 'atcMiniCartCheckoutLabel', tab: 'AddToCartTab' },
  { name: 'atcMiniCartShopingCartLabel', tab: 'AddToCartTab' },
  { name: 'atcMiniCartEmptyCartLabel', tab: 'AddToCartTab' },
  { name: 'atcMiniCartViewCartLabel', tab: 'AddToCartTab' },
  { name: 'atcAddingToCartBtnLabel', tab: 'AddToCartTab' },
  { name: 'atcAddedToCartBtnLabel', tab: 'AddToCartTab' },
  { name: 'atcMiniCartCountItemLabel', tab: 'AddToCartTab' },
  { name: 'atcMiniCartCountItemLabelPlural', tab: 'AddToCartTab' },

  { name: 'recentProductHeading', tab: 'RecentlyViewedMostPopularTab' },
  { name: 'popularProductsHeading', tab: 'RecentlyViewedMostPopularTab' }
];

export const ITEMS_V2 = [
  { name: 'refineDesktop', tab: 'FilterTab' },
  { name: 'refine', tab: 'FilterTab' },
  { name: 'refineMobile', tab: 'FilterTab' },
  { name: 'refineMobileCollapse', tab: 'FilterTab' },
  { name: 'clear', tab: 'FilterTab' },
  { name: 'clearAll', tab: 'FilterTab' },
  { name: 'viewMore', tab: 'FilterTab' },
  { name: 'viewLess', tab: 'FilterTab' },
  { name: 'apply', tab: 'FilterTab' },
  { name: 'applyAll', tab: 'FilterTab' },
  { name: 'close', tab: 'FilterTab' },
  { name: 'back', tab: 'FilterTab' },
  { name: 'showLimit', tab: 'FilterTab' },
  { name: 'collectionAll', tab: 'FilterTab' },
  { name: 'under', tab: 'FilterTab' },
  { name: 'above', tab: 'FilterTab' },
  { name: 'ratingStar', tab: 'FilterTab' },
  { name: 'ratingStars', tab: 'FilterTab' },
  { name: 'ratingUp', tab: 'FilterTab' },
  { name: 'showResult', tab: 'FilterTab' },
  { name: 'searchOptions', tab: 'FilterTab' },

  { name: 'sorting', tab: 'SortByTab' },

  { name: 'generalTitle', group: 'searchPage', tab: 'SearchPageTab' },
  { name: 'resultHeader', group: 'searchPage', tab: 'SearchPageTab' },
  // { name: 'inputSearchPlaceholder',group: 'searchPage', tab: 'SearchPageTab' }, // addon field from FE team
  { name: 'resultNumber', group: 'searchPage', tab: 'SearchPageTab' },
  { name: 'seeAllProducts', group: 'searchPage', tab: 'SearchPageTab' },
  { name: 'resultEmpty', group: 'searchPage', multiline: 2, tab: 'SearchPageTab' },
  {
    name: 'resultEmptyWithSuggestion',
    group: 'searchPage',
    multiline: 2,
    tab: 'SearchPageTab'
  },
  { name: 'searchTotalResult', group: 'searchPage', tab: 'SearchPageTab' },
  { name: 'searchTotalResults', group: 'searchPage', tab: 'SearchPageTab' },
  { name: 'searchPanelProduct', group: 'searchPage', tab: 'SearchPageTab' },
  { name: 'searchPanelCollection', group: 'searchPage', tab: 'SearchPageTab' },
  { name: 'searchPanelPage', group: 'searchPage', tab: 'SearchPageTab' },
  { name: 'searchTipsTitle', group: 'searchPage', tab: 'SearchPageTab' },
  { name: 'searchTipsContent', group: 'searchPage', multiline: 4, tab: 'SearchPageTab' },

  { name: 'viewAll', tab: 'InstantSearchDisplayTab' },
  { name: 'didYouMean', tab: 'InstantSearchDisplayTab' },
  { name: 'searchBoxPlaceholder', tab: 'InstantSearchDisplayTab' },
  { name: 'suggestQuery', tab: 'InstantSearchDisplayTab' },
  { name: 'instantSearchSuggestionsLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'instantSearchCollectionsLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'instantSearchProductsLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'instantSearchPagesLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'searchBoxOnclickRecentSearchLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'searchBoxOnclickSearchTermLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'searchBoxOnclickProductsLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'noSearchResultSearchTermLabel', tab: 'InstantSearchDisplayTab' },
  { name: 'noSearchResultProductsLabel', tab: 'InstantSearchDisplayTab' },

  { name: 'textDescriptionCollectionHeaderV2', group: 'collectionHeader', tab: 'ProductTab' }, // new
  { name: 'textDescriptionCollectionHeaderPluralV2', group: 'collectionHeader', tab: 'ProductTab' }, // new
  { name: 'inCollectionSearch', group: 'collectionHeader', tab: 'ProductTab' },
  { name: 'collectionAllProduct', group: 'collectionHeader', tab: 'ProductTab' },
  { name: 'homeBreadcrumb', group: 'collectionHeader', tab: 'ProductTab' },
  { name: 'collectionsBreadcrumb', group: 'collectionHeader', tab: 'ProductTab' },
  { name: 'paginationBreadcrumb', group: 'collectionHeader', tab: 'ProductTab' },
  { name: 'toFrontPageBreadcrumb', group: 'collectionHeader', tab: 'ProductTab' },

  { name: 'viewAsV2', group: 'toolbar', tab: 'ProductTab' },
  { name: 'gridViewV2', group: 'toolbar', tab: 'ProductTab' },
  { name: 'listViewV2', group: 'toolbar', tab: 'ProductTab' },
  { name: 'gridViewColumnsV2', group: 'toolbar', tab: 'ProductTab' },
  { name: 'productCountPerPageV2', group: 'toolbar', tab: 'ProductTab' }, // new
  { name: 'textDescriptionToolbarV2', group: 'toolbar', tab: 'ProductTab' }, // new
  { name: 'textDescriptionToolbarPluralV2', group: 'toolbar', tab: 'ProductTab' }, // new

  { name: 'atcAvailableLabelV2', group: 'productItem', tab: 'ProductTab' },
  { name: 'atcSelectOptionsLabelV2', group: 'productItem', tab: 'ProductTab' },
  { name: 'atcAddingToCartBtnLabelV2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'atcAddedToCartBtnLabelV2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'atcFailedToCartBtnLabel', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'qvBtnLabelV2', group: 'productItem', tab: 'ProductTab' },
  { name: 'viewProductBtnLabelV2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'amountV2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'savingAmountV2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'productItemSaleV2', group: 'productItem', tab: 'ProductTab' },
  { name: 'swatchButtonText1V2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'swatchButtonText2V2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'swatchButtonText3V2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'atcSoldOutLabelV2', group: 'productItem', tab: 'ProductTab' },
  { name: 'inventoryInStockV2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'inventoryLowStockV2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'inventorySoldOutV2', group: 'productItem', tab: 'ProductTab' }, // new
  { name: 'productItemSoldOutV2', group: 'productItem', tab: 'ProductTab' },

  { name: 'loadPreviousTextV2', group: 'pagination', tab: 'ProductTab' },
  { name: 'loadPreviousInfiniteTextV2', group: 'pagination', tab: 'ProductTab' },
  { name: 'prevTextV2', group: 'pagination', tab: 'ProductTab' }, // new
  { name: 'nextTextV2', group: 'pagination', tab: 'ProductTab' }, // new
  { name: 'loadMoreTextV2', group: 'pagination', tab: 'ProductTab' },
  { name: 'textDescriptionPaginationV2', group: 'pagination', tab: 'ProductTab' }, // new
  { name: 'textDescriptionPaginationPluralV2', group: 'pagination', tab: 'ProductTab' }, // new

  { name: 'buyItNowBtnLabelV2', group: 'quickView', tab: 'ProductTab' },
  { name: 'qvQuantityV2', group: 'quickView', tab: 'ProductTab' },
  { name: 'qvViewFullDetailsV2', group: 'quickView', tab: 'ProductTab' },
  { name: 'qvQuantityError', group: 'quickView', tab: 'ProductTab' },
  { name: 'qvPrevButton', group: 'quickView', tab: 'ProductTab' },
  { name: 'qvNextButton', group: 'quickView', tab: 'ProductTab' },

  { name: 'atcMiniCartShopingCartLabelV2', group: 'ajaxCart', tab: 'ProductTab' }, // your cart
  { name: 'atcMiniCartViewCartLabelV2', group: 'ajaxCart', tab: 'ProductTab' },
  { name: 'atcMiniCartCheckoutLabelV2', group: 'ajaxCart', tab: 'ProductTab' },
  { name: 'atcMiniCartCountItemLabelV2', group: 'ajaxCart', tab: 'ProductTab' },
  { name: 'atcMiniCartCountItemLabelPluralV2', group: 'ajaxCart', tab: 'ProductTab' },
  { name: 'atcMiniCartSubtotalLabelV2', group: 'ajaxCart', tab: 'ProductTab' },
  { name: 'atcMiniCartEmptyCartLabelV2', group: 'ajaxCart', tab: 'ProductTab' },
  // { name: 'atcPopupCheckoutLabel', group: 'ajaxCart', tab: 'ProductTab' }, // addon field from FE team
  // { name: 'atcPopupGoToCartLabel', group: 'ajaxCart', tab: 'ProductTab' }, // addon field from FE team
  // { name: 'atcMiniCartItemQuantity', group: 'ajaxCart', tab: 'ProductTab' }, // addon field from FE team
  // { name: 'atcMiniCartRemoveItemLabel', group: 'ajaxCart', tab: 'ProductTab' }, // addon field from FE team

  { name: 'noFilterResult', tab: 'NoResultsDisplayTab' },
  { name: 'noSearchResult', tab: 'NoResultsDisplayTab' },
  { name: 'noProducts', tab: 'NoResultsDisplayTab' },
  { name: 'noSuggestionResult', tab: 'NoResultsDisplayTab' },
  { name: 'noSuggestionProducts', tab: 'NoResultsDisplayTab' },

  { name: 'recentProductHeading', tab: 'OldVersionTab' },
  { name: 'popularProductsHeading', tab: 'OldVersionTab' },

  { name: 'toolbarViewAs', group: 'defaultTheme', tab: 'OldVersionTab' },
  { name: 'toolbarProduct', group: 'defaultTheme', tab: 'OldVersionTab' },
  { name: 'toolbarProducts', group: 'defaultTheme', tab: 'OldVersionTab' },
  { name: 'productItemSale', group: 'defaultTheme', tab: 'OldVersionTab' },
  { name: 'productItemSoldOut', group: 'defaultTheme', tab: 'OldVersionTab' },

  { name: 'gridView', group: 'collectionPage', tab: 'OldVersionTab' },
  { name: 'listView', group: 'collectionPage', tab: 'OldVersionTab' },
  { name: 'gridViewColumns', group: 'collectionPage', tab: 'OldVersionTab' },
  { name: 'loadPreviousPage', group: 'collectionPage', tab: 'OldVersionTab' },
  { name: 'loadMore', group: 'collectionPage', tab: 'OldVersionTab' },
  { name: 'loadMoreTotal', group: 'collectionPage', tab: 'OldVersionTab' },

  { name: 'qvBtnLabel', group: 'quickView', tab: 'OldVersionTab' },
  { name: 'qvAddToCartBtnLabel', group: 'quickView', tab: 'OldVersionTab' },
  { name: 'qvSaleLabel', group: 'quickView', tab: 'OldVersionTab' },
  { name: 'qvSoldOutLabel', group: 'quickView', tab: 'OldVersionTab' },
  { name: 'qvQuantity', group: 'quickView', tab: 'OldVersionTab' },
  { name: 'qvViewFullDetails', group: 'quickView', tab: 'OldVersionTab' },

  { name: 'atcAvailableLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcSelectOptionsLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcSoldOutLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcMiniCartSubtotalLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcMiniCartCheckoutLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcMiniCartShopingCartLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcMiniCartEmptyCartLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcMiniCartViewCartLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcAddingToCartBtnLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcAddedToCartBtnLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcMiniCartCountItemLabel', group: 'addToCart', tab: 'OldVersionTab' },
  { name: 'atcMiniCartCountItemLabelPlural', group: 'addToCart', tab: 'OldVersionTab' },

  { name: 'predictiveBundleTotalPrice', group: 'predictiveBundle', tab: 'PredictiveBundleTab' },
  { name: 'predictiveBundleAddBundleToCart', group: 'predictiveBundle', tab: 'PredictiveBundleTab' }
  // { name: 'searchAutoComplete', group: 'addToCart', tab: 'OldVersionTab' } // addon field from FE team
];

export const SORT_BY_OPTION_DISPLAY_DEFAULT = {
  relevance: '{{relevance}}',
  'best-selling': '{{best-selling}}',
  manual: '{{manual}}',
  'price-ascending': '{{price}} - {{ascending}}',
  'price-descending': '{{price}} - {{descending}}',
  'title-ascending': '{{title}} - {{ascending}}',
  'title-descending': '{{title}} - {{descending}}',
  'created-ascending': '{{created}} - {{ascending}}',
  'created-descending': '{{created}} - {{descending}}'
};
